import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./orgaos.component.html')
})
export class OrgaosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/orgaos.component.ts
 **/